export default __webpack_public_path__ + "static/media/pp-11.2d676ed7.svg";